import pdfMake from 'pdfmake/build/pdfmake';

// Простая инициализация шрифтов
let simpleFontsLoaded = false;

const initializeSimpleFonts = async () => {
  if (simpleFontsLoaded) return;
  
  try {
    const pdfFonts = await import('pdfmake/build/vfs_fonts');
    if (!pdfMake.vfs) {
      pdfMake.vfs = pdfFonts.default?.pdfMake?.vfs || pdfFonts.default?.vfs || pdfFonts.pdfMake?.vfs || pdfFonts.vfs;
    }
    simpleFontsLoaded = true;
    console.log('✅ Шрифты для простого PDF загружены');
  } catch (error) {
    console.warn('⚠️ Ошибка загрузки шрифтов:', error);
    // Продолжаем работу со встроенными шрифтами
  }
};

// Создание простого PDF документа
function createSimplePDF(data) {
  const {
    shopData,
    productData,
    dimensionsData,
    glassData,
    hardwareData,
    calculationResult,
    finalPrice
  } = data;

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [25, 40, 25, 40],
    
    content: [
      // Заголовок
      {
        text: 'КОММЕРЧЕСКОЕ ПРЕДЛОЖЕНИЕ',
        style: 'title',
        alignment: 'center',
        margin: [0, 0, 0, 20]
      },

      // Информация о магазине
      ...(shopData ? [
        {
          text: shopData.name || 'Магазин',
          style: 'shopName',
          margin: [0, 0, 0, 5]
        },
        ...(shopData.address ? [{
          text: shopData.address,
          style: 'shopDetail',
          margin: [0, 0, 0, 2]
        }] : []),
        ...(shopData.contact_info?.['тел'] ? [{
          text: `Телефон: ${shopData.contact_info['тел']}`,
          style: 'shopDetail',
          margin: [0, 0, 0, 2]
        }] : []),
        ...(shopData.contact_info?.email ? [{
          text: `Email: ${shopData.contact_info.email}`,
          style: 'shopDetail',
          margin: [0, 0, 0, 2]
        }] : []),
        {
          canvas: [{ type: 'line', x1: 0, y1: 5, x2: 545, y2: 5, lineWidth: 1, lineColor: '#dddddd' }],
          margin: [0, 10, 0, 15]
        }
      ] : []),

      // Продукт
      ...(productData ? [
        {
          text: 'МОДЕЛЬ ДУШЕВОЙ КАБИНЫ',
          style: 'sectionHeader',
          margin: [0, 5, 0, 5]
        },
        {
          text: productData.name || 'Не указано',
          style: 'itemName',
          margin: [8, 0, 0, 3]
        },
        ...(productData.description ? [{
          text: productData.description,
          style: 'itemDesc',
          margin: [8, 0, 0, 10]
        }] : [])
      ] : []),

      // Размеры
      ...(dimensionsData && Object.keys(dimensionsData).length > 0 ? [
        {
          text: 'РАЗМЕРЫ КАБИНЫ',
          style: 'sectionHeader',
          margin: [0, 5, 0, 5]
        },
        {
          columns: [
            {
              width: '*',
              stack: Object.entries(dimensionsData).map(([key, dimension]) => ({
                text: `${dimension.label}: ${dimension.value} мм`,
                style: 'dimensionItem',
                margin: [8, 2, 0, 2]
              }))
            }
          ],
          margin: [0, 0, 0, 10]
        }
      ] : []),

      // Стекло
      ...(glassData ? [
        {
          text: 'ТИП СТЕКЛА',
          style: 'sectionHeader',
          margin: [0, 5, 0, 5]
        },
        {
          text: glassData.name,
          style: 'itemName',
          margin: [8, 0, 0, 3]
        },
        ...(glassData.description ? [{
          text: glassData.description,
          style: 'itemDesc',
          margin: [8, 0, 0, 3]
        }] : []),
        ...(glassData.thickness ? [{
          text: `Толщина: ${glassData.thickness} мм`,
          style: 'itemDesc',
          margin: [8, 0, 0, 3]
        }] : []),
        ...(calculationResult?.calculation?.glass_area ? [{
          text: `Площадь стекла: ${calculationResult.calculation.glass_area} м²`,
          style: 'itemDesc',
          margin: [8, 0, 0, 10]
        }] : [])
      ] : []),

      // Фурнитура
      ...(hardwareData ? [
        {
          text: 'ФУРНИТУРА',
          style: 'sectionHeader',
          margin: [0, 5, 0, 5]
        },
        {
          text: hardwareData.name,
          style: 'itemName',
          margin: [8, 0, 0, 3]
        },
        ...(hardwareData.description ? [{
          text: hardwareData.description,
          style: 'itemDesc',
          margin: [8, 0, 0, 5]
        }] : []),

        ...(hardwareData.hardware_items && hardwareData.hardware_items.length > 0 ? [
          {
            text: 'Состав:',
            style: 'itemDesc',
            bold: true,
            margin: [8, 0, 0, 5]
          },
          {
            ul: hardwareData.hardware_items.map(item => ({
              text: `${item.hardware_details?.display_name || 
                      item.hardware_details?.name || 
                      'Не указано'} — ${item.quantity} шт.`,
              style: 'hardwareItem'
            })),
            margin: [15, 0, 0, 10]
          }
        ] : [])
      ] : []),

      // Итоговая стоимость
      ...(finalPrice ? [
        {
          canvas: [{ type: 'rect', x: 0, y: 0, w: 545, h: 40, color: '#f8f9fa', lineColor: '#28a745', lineWidth: 2 }],
          margin: [0, 15, 0, 0]
        },
        {
          text: 'Итоговая стоимость:',
          style: 'priceLabel',
          alignment: 'center',
          margin: [0, -35, 0, 5]
        },
        {
          text: `${finalPrice.toLocaleString('ru-RU')} ₽`,
          style: 'finalPrice',
          alignment: 'center',
          margin: [0, 0, 0, 15]
        }
      ] : []),

      // Подвал
      {
        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 545, y2: 5, lineWidth: 1, lineColor: '#eeeeee' }],
        margin: [0, 20, 0, 10]
      },
      {
        text: 'Спасибо за обращение! Будем рады сотрудничеству.',
        style: 'footer',
        alignment: 'center',
        margin: [0, 0, 0, 5]
      },
      ...(calculationResult?.timestamp ? [{
        text: `Дата расчета: ${new Date(calculationResult.timestamp).toLocaleString('ru-RU')}`,
        style: 'footerDate',
        alignment: 'center'
      }] : [])
    ],

    styles: {
      title: {
        fontSize: 16,
        bold: true,
        color: '#333333'
      },
      shopName: {
        fontSize: 13,
        bold: true,
        color: '#333333'
      },
      shopDetail: {
        fontSize: 9,
        color: '#666666'
      },
      sectionHeader: {
        fontSize: 11,
        bold: true,
        color: '#444444'
      },
      itemName: {
        fontSize: 10,
        bold: true,
        color: '#333333'
      },
      itemDesc: {
        fontSize: 9,
        color: '#666666'
      },
      dimensionItem: {
        fontSize: 9
      },
      hardwareItem: {
        fontSize: 8
      },
      priceLabel: {
        fontSize: 11,
        color: '#666666'
      },
      finalPrice: {
        fontSize: 18,
        bold: true,
        color: '#28a745'
      },
      footer: {
        fontSize: 9,
        color: '#888888'
      },
      footerDate: {
        fontSize: 8,
        color: '#aaaaaa'
      }
    },

    defaultStyle: {
      font: 'Roboto'
    }
  };

  return docDefinition;
}

// Создание простого PDF
export function generateSimpleQuotePDF(data) {
  return {
    download: async (filename) => {
      try {
        console.log('🎯 Генерируем простой PDF с pdfMake...');
        
        // Загружаем шрифты перед созданием PDF
        await initializeSimpleFonts();
        
        const docDefinition = createSimplePDF(data);
        const pdfDoc = pdfMake.createPdf(docDefinition);
        pdfDoc.download(filename);
        console.log('✅ Простой PDF успешно создан с pdfMake');
      } catch (error) {
        console.error('❌ Ошибка создания простого PDF:', error);
        throw error;
      }
    },
    getBlob: async () => {
      try {
        await initializeSimpleFonts();
        const docDefinition = createSimplePDF(data);
        const pdfDoc = pdfMake.createPdf(docDefinition);
        return new Promise((resolve) => {
          pdfDoc.getBlob((blob) => {
            resolve(blob);
          });
        });
      } catch (error) {
        console.error('❌ Ошибка создания blob простого PDF:', error);
        return null;
      }
    },
    getPdf: async () => {
      try {
        await initializeSimpleFonts();
        const docDefinition = createSimplePDF(data);
        return pdfMake.createPdf(docDefinition);
      } catch (error) {
        console.error('❌ Ошибка создания PDF объекта:', error);
        return null;
      }
    }
  };
}

export default { generateSimpleQuotePDF }; 